var _templateObject;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Inpsiration taken from https://github.com/mui-org/material-ui/blob/v1-beta/packages/material-ui-icons/src/utils/createSvgIcon.js


import React from 'react';
import PropTypes from 'prop-types';
import MuiSvgIcon from '@material-ui/core/SvgIcon';
import styled from 'styled-components';
import flow from 'lodash/flow';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import { createSelector } from 'reselect';
import { paletteGreySelector, typographySelector } from '@signal/theme/selectors';
import getSvg from './importSvg'; // Prop selectors

var greyHueSelector = function greyHueSelector(props) {
  return props.grey;
};

var sizeSelector = function sizeSelector(props) {
  return props.size;
};

var fillSelector = function fillSelector(props) {
  return props.fillColor;
};

export var SignalSvg = styled(function (_ref) {
  var iconColor = _ref.iconColor,
      fillColor = _ref.fillColor,
      rest = _objectWithoutProperties(_ref, ["iconColor", "fillColor"]);

  return /*#__PURE__*/React.createElement(MuiSvgIcon, rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n"])), // if the `grey` prop is set, the color of the icon should use that hue of grey
createSelector(greyHueSelector, paletteGreySelector, function (hue, paletteGrey) {
  return paletteGrey[hue] && "color: ".concat(paletteGrey[hue], ";");
}), // if the `size` prop is set, the font size of the icon should respect it
createSelector(sizeSelector, typographySelector, function (size, typography) {
  return size && "font-size: ".concat(typography.pxToRem(size), ";");
}), // if the `fill` prop is set, the fill of the icon should respect it
createSelector(fillSelector, function (fillColor) {
  return fillColor && ".fill { fill: ".concat(fillColor, "; }");
}));
export var SignalSvgPropTypes = {
  // The hue of grey to make the icon
  grey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.number,
  fillColor: PropTypes.string
}; // use this only for off-center situations in the original svg -  all icons must be sized to 24x24

var ICON_VIEWBOXES = {
  advertise: '-2 -4 24 24',
  infoBubble: '-1 -1 24 24',
  insights: '-0.5 0 24 24',
  inventory: '-1 -1 24 24',
  pushPinNew: '-3.5 -1 24 24'
};
/**
 * Creates an SVG icon React component using the SVG with the provided filename.
 *
 * NOTE: Each SVG should be created with a 24x24 viewport, as it will be
 * rendered with a `viewBox` value of `"0 0 24 24"` unless overridden above
 *
 * @param {String} iconFilename - Filename of an icon inside the `svg` directory
 * if not provided, falls back to the icon filename pascal cased.
 * @return {Component} - SVG icon React component
 */

export function createSvgIcon(iconFilename) {
  var SignalIcon = function SignalIcon(props) {
    return /*#__PURE__*/React.createElement(SignalSvg, Object.assign({}, props, {
      component: getSvg(iconFilename),
      viewBox: ICON_VIEWBOXES[camelCase(iconFilename)]
    }), iconFilename);
  }; // If displayName not provided, fallback to pascal case iconFilename


  SignalIcon.displayName = flow(camelCase, upperFirst)(iconFilename);
  SignalIcon.propTypes = SignalSvgPropTypes;
  return SignalIcon;
}
export default createSvgIcon;